export class PaymentHistoryYears {
    success: boolean = false;
    years: number[] = [];
    minYear: number = 0;
    maxYear: number = 0;
    currentIndex: number = 0;
}
